import * as types from "../actions/types";
const initialState = {
    list: [],
    listLoading: false,
    listLoaded: 0,
};

function recommandations(state = initialState, action) {
    switch (action.type) {
        case types.RECOMMANDATIONS_FETCH_REQUESTED: {
            return Object.assign({}, state, {
                listLoading: true,
                listLoaded: 0,
            });
        }
        case types.RECOMMANDATIONS_FETCH_SUCCESS: {
            return Object.assign({}, state, {
                listLoading: false,
                list: action.data,
                listLoaded: Date.now()
            });
        }
        case types.RECOMMANDATIONS_FETCH_FAILURE: {
            return Object.assign({}, state, { listLoading: false, list: [] });
        }
        default:
            return state;
    }
}

export default recommandations;
